export const getFuelIcon = () => `<svg version="1.1" width="150" height="150" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 150 150" style="enable-background:new 0 0 150 150;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#51BF47;}
	.st1{fill:none;stroke:#379544;stroke-width:9.998;stroke-linecap:round;stroke-linejoin:round;}
	.st2{fill:#FFFFFF;}
	.st3{display:none;}
	.st4{display:inline;fill:#201600;stroke:#201600;stroke-width:0.1;stroke-linecap:square;stroke-miterlimit:10;}
</style>
<g id="Слой_1">
	<g id="XMLID_66_">
		<g>
			<path id="XMLID_75_" class="st0" d="M75,145.1c38.6,0,70.1-31.3,70.1-70.1C145.1,36.4,113.7,5,75,5C36.4,5,5,36.3,5,75
				C4.9,113.6,36.4,145.1,75,145.1z"/>
			<path id="XMLID_74_" class="st1" d="M139.9,75c0,35.9-29.1,64.9-64.9,64.9s-64.9-29-64.9-64.9s29-64.9,64.9-64.9
				S139.9,39.1,139.9,75z"/>
		</g>
		<path id="XMLID_73_" class="st2" d="M46.2,52.5c0-8.3,6.8-15,15-15h15.1c8.3,0,15,6.8,15,15v20.7l0,0c6,0,10.9,4.9,10.9,10.9v14.2
			c0,1.3,1,2.3,2.3,2.3s2.3-1,2.3-2.3V70.9c-0.9,0.3-1.8,0.4-2.7,0.4c-5.1,0-9.3-4.2-9.3-9.3c0-3.7,2.2-6.9,5.2-8.4l-5-5
			c-1.3-1.3-1.3-3.5,0-4.7c1.3-1.3,3.5-1.3,4.7,0l10.6,10.6c2,2,3.2,4.9,3.2,7.7v36.3c0,5-4.1,8.9-8.9,8.9c-5,0-8.9-4.1-8.9-8.9
			V84.1c0-2.3-1.8-4.1-4.1-4.1l0,0v17.5c0,8.3-6.8,15-15,15H61.2c-8.3,0-15-6.8-15-15V52.5z"/>
		<path id="XMLID_72_" class="st0" d="M53.8,52.5c0-4.1,3.3-7.5,7.5-7.5h15c4.1,0,7.5,3.3,7.5,7.5v11.2c0,4.1-3.3,7.5-7.5,7.5H61.2
			c-4.1,0-7.4-3.5-7.4-7.5V52.5z"/>
		<circle id="XMLID_71_" class="st0" cx="104" cy="61.8" r="2.7"/>
	</g>
</g>
<g id="Linear" class="st3">
	<line id="XMLID_70_" class="st4" x1="145" y1="-1.8" x2="145" y2="166.9"/>
	<line id="XMLID_69_" class="st4" x1="155.5" y1="145" x2="-13.2" y2="145"/>
	<line id="XMLID_68_" class="st4" x1="5" y1="-12" x2="5" y2="156.7"/>
	<line id="XMLID_67_" class="st4" x1="158.3" y1="5" x2="-10.4" y2="5"/>
</g>
</svg>
`